import { render, staticRenderFns } from "./ChipRequests.vue?vue&type=template&id=75d4c098&lang=pug"
import script from "./ChipRequests.vue?vue&type=script&lang=js"
export * from "./ChipRequests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports